import { atom } from 'jotai'
import { tabs } from 'app/config/app'

export type TabValue = (typeof tabs)[keyof typeof tabs]

export const switchTabAtom = atom<TabValue>(tabs.TOP)
